/**
 * **A09 · The setup-week binder cover and tabs** (Stream A, Paper.dc.html), laid out by the
 * `setup_binder` engine: the setup week's days from Festival Ops → Setup & strike (Year settings),
 * the strike after, the setup channel from the radio plan; each day's work, deliveries and crew
 * print NO DATA until the setup week's plan is kept (WORKLIST ops-new). Scored by walk 99g.
 */
import type { ReactNode } from 'react';
import { setupBinder, type RadioPlan } from '@cider/domain/engines';
import { useLoad } from '../views/money/shared.js';
import { usePrinted } from './printed.js';
import { DrawnPages } from './drawn-doc.js';

export function SetupBinder({ year }: { year: string }): ReactNode {
  const d = useLoad<{ setupDays: string[] | null }>(`/ops/setup-strike?year=${year}`);
  const plan = useLoad<RadioPlan>(`/ops/radio-plan?year=${year}`);
  const ready = !!d.data && (plan.data !== null || plan.error !== null);
  usePrinted('setup-binder', ready, { year: Number(year) });
  if (d.error) return <p role="alert">{d.error}</p>;
  if (!ready) return <p>Reading the setup week…</p>;
  const channel = plan.data?.channels.find((c) => /setup/i.test(c.use))?.channel ?? null;
  return (
    <DrawnPages
      pages={setupBinder({ year: Number(year), days: d.data?.setupDays ?? null, channel })}
      stamp="time"
    />
  );
}
